module.exports = __webpack_public_path__ + "img/face-anxious-sweat.4f9a7408.svg";